import { ReactNode } from 'react'
import { useImmerReducer } from 'use-immer'

import { SessionContext, initialState } from './session_context'
import { sessionReducer } from './session_reducer'

export type SessionProviderProps = {
  children: ReactNode
}

export const SessionProvider = ({ children }: SessionProviderProps) => {
  const [state, dispatch] = useImmerReducer(sessionReducer, initialState)
  const { Provider } = SessionContext

  return <Provider value={{ state, dispatch }}> {children} </Provider>
}
